<template lang="pug">
footer#v-footer.container
  .link
    a(href='https://www.facebook.com/TechOrange/?fref=ts', target='_blank')
      img(src='@/assets/facebook.png', :width='$store.state.mobile ? "50" : "80"')
      | 加入 TechOrange 粉絲團
    a(href='https://buzzorange.com/techorange/info/', target='_blank')
      img(src='@/assets/contact.png', :width='$store.state.mobile ? "50" : "80"')
      | 聯絡我們
  .copyright
    | Copyright © 2019 流線傳媒有限公司 All rights reserved.
    |
    br(v-if='$store.state.mobile')
    a(href='https://buzzorange.com/techorange/', target='_blank') TechOrange科技報橘
    | ｜
    a(href='https://buzzorange.com/', target='_blank') BuzzOrange報橘
    | ｜
    a(href='https://buzzorange.com/vidaorange/', target='_blank') VidaOrange生活報橘
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-footer
  text-align: center
.link
  margin: 0 auto 60px
  a
    +font(18px, #656565, null, .17px, 500)
    display: inline-block
    width: 300px
    img
      display: block
      margin: 0 auto 26px
.copyright
  +font(14px, #5A5A5A)
  padding-bottom: 30px
  padding-top: 30px

@media (max-width: 1023px)
  .link
    margin-bottom: 30px
    a
      +font(12px, null, null, .11px)
      display: block
      margin-bottom: 34px
      width: auto
      img
        margin-bottom: 10px
  .copyright
    +font(12px, null, 18px)
    padding-bottom: 10px
    padding-top: 30px
    transform-origin: .5em 1em
    transform: scale(.75)
    width: 132%
</style>
